"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var CoreSuspender_1 = require("../CoreSuspender");
var onShortcut_1 = __importDefault(require("../Shortcuts/onShortcut"));
var useSettings_1 = __importDefault(require("../useSettings"));
var FullscreenContext_1 = __importDefault(require("./FullscreenContext"));
var Platform_1 = require("../Platform");
var hasWebkitFullscreen = typeof HTMLVideoElement !== 'undefined' &&
    typeof HTMLVideoElement.prototype.webkitEnterFullscreen === 'function';
var FullscreenProvider = function (_a) {
    var children = _a.children;
    var shell = (0, Platform_1.usePlatform)().shell;
    var settings = (0, useSettings_1.default)()[0];
    var escExitFullscreen = settings.escExitFullscreen;
    var videoElementRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(false), hasVideoElement = _b[0], setHasVideoElement = _b[1];
    var _c = (0, react_1.useState)(function () {
        if (typeof document === 'undefined')
            return false;
        return document.fullscreenElement === document.documentElement;
    }), fullscreen = _c[0], setFullscreen = _c[1];
    var setVideoElement = (0, react_1.useCallback)(function (el) {
        videoElementRef.current = el;
        setHasVideoElement(el !== null);
    }, []);
    var supported = shell.active || document.fullscreenEnabled === true || (hasVideoElement && hasWebkitFullscreen);
    var requestFullscreen = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shell.active) return [3 /*break*/, 1];
                    shell.send('win-set-visibility', { fullscreen: true });
                    return [3 /*break*/, 7];
                case 1:
                    if (!document.fullscreenEnabled) return [3 /*break*/, 6];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, document.documentElement.requestFullscreen()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    console.error('Error enabling fullscreen', err_1);
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 7];
                case 6:
                    if (videoElementRef.current && hasWebkitFullscreen) {
                        videoElementRef.current.webkitEnterFullscreen();
                    }
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); }, [shell]);
    var exitFullscreen = (0, react_1.useCallback)(function () {
        if (shell.active) {
            shell.send('win-set-visibility', { fullscreen: false });
        }
        else if (document.fullscreenElement === document.documentElement) {
            document.exitFullscreen();
        }
        else if (videoElementRef.current && videoElementRef.current.webkitDisplayingFullscreen) {
            videoElementRef.current.webkitExitFullscreen();
        }
    }, [shell]);
    var toggleFullscreen = (0, react_1.useCallback)(function () {
        fullscreen ? exitFullscreen() : requestFullscreen();
    }, [fullscreen, exitFullscreen, requestFullscreen]);
    (0, onShortcut_1.default)('fullscreen', toggleFullscreen, [toggleFullscreen]);
    (0, react_1.useEffect)(function () {
        var videoElement = videoElementRef.current;
        var onWindowVisibilityChanged = function (state) {
            setFullscreen(state.isFullscreen === true);
        };
        var onFullscreenChange = function () {
            setFullscreen(document.fullscreenElement === document.documentElement);
        };
        var onWebkitFullscreenChange = function () {
            setFullscreen((videoElement === null || videoElement === void 0 ? void 0 : videoElement.webkitDisplayingFullscreen) === true);
        };
        var onKeyDown = function (event) {
            if (event.code === 'Escape' && escExitFullscreen) {
                exitFullscreen();
            }
            if (event.code === 'F11' && shell.active) {
                toggleFullscreen();
            }
        };
        shell.on('win-visibility-changed', onWindowVisibilityChanged);
        document.addEventListener('keydown', onKeyDown);
        document.addEventListener('fullscreenchange', onFullscreenChange);
        videoElement === null || videoElement === void 0 ? void 0 : videoElement.addEventListener('webkitbeginfullscreen', onWebkitFullscreenChange);
        videoElement === null || videoElement === void 0 ? void 0 : videoElement.addEventListener('webkitendfullscreen', onWebkitFullscreenChange);
        return function () {
            shell.off('win-visibility-changed', onWindowVisibilityChanged);
            document.removeEventListener('keydown', onKeyDown);
            document.removeEventListener('fullscreenchange', onFullscreenChange);
            videoElement === null || videoElement === void 0 ? void 0 : videoElement.removeEventListener('webkitbeginfullscreen', onWebkitFullscreenChange);
            videoElement === null || videoElement === void 0 ? void 0 : videoElement.removeEventListener('webkitendfullscreen', onWebkitFullscreenChange);
        };
    }, [shell, toggleFullscreen, exitFullscreen, escExitFullscreen, hasVideoElement]);
    var value = (0, react_1.useMemo)(function () { return [fullscreen, requestFullscreen, exitFullscreen, toggleFullscreen, supported, setVideoElement]; }, [fullscreen, requestFullscreen, exitFullscreen, toggleFullscreen, supported, setVideoElement]);
    return (react_1.default.createElement(FullscreenContext_1.default.Provider, { value: value }, children));
};
exports.default = (0, CoreSuspender_1.withCoreSuspender)(FullscreenProvider);
